import { Component } from '@angular/core';

@Component({
    selector: 'app-messaging-admin',
    templateUrl: './messaging-admin.component.html',
    styleUrls: ['./messaging-admin.component.scss'],
    standalone: false
})
export class MessagingAdminComponent {

}
